import { DirectoryHttpService } from "../http/DirectoryHttpService";
import { ItemCategory } from "../models/entities/items/item-category";

export class ItemCategoryService
{

    controllerName:string = "ItemCategories";

    constructor(private http:DirectoryHttpService)
    {


    }


    getList(filter:{
        searchString?:string,
        skip?:number,
        take?:number,
        includeInactive?:boolean
    } = undefined)
    {
        return this.http.post<ItemCategory[]>(`/${this.controllerName}/GetList`, {
            body:filter
        });
    }

    find(id:string)
    {

        return this.http.post<ItemCategory>(`/${this.controllerName}/Find`, {
            hokQuery:{
                id
            }
        });
    }

    save(input:ItemCategory)
    {
        return this.http.post<ItemCategory>(`/${this.controllerName}/Save`, {
            body:input
        });
    }
}

